export const LOAD_ALARM_DEVICE_DETAILS = '[devices] load alarm device details';
export const PROCESS_ALARM_DEVICE_DETAILS =
  '[devices] process alarm device details';
export const ADD_ALARM_DEVICE_DETAILS = '[devices] add alarm device details';

export const LOAD_UNASSIGNED_ALARM_DEVICE_DETAILS =
  '[devices] load unassigned alarm device details';
export const LOAD_UNASSIGNED_POI_DEVICE_DETAILS =
  '[devices] load unassigned poi device details';
export const PROCESS_UNASSIGNED_ALARM_DEVICE_DETAILS =
  '[devices] process unassigned alarm device details';
export const ADD_UNASSIGNED_ALARM_DEVICE_DETAILS =
  '[devices] add unassigned alarm device details';

export const ADD_ASSIGNED_ALARM_DEVICES =
  '[devices] add associated alarm devices';

export const ADD_ALARM_DEVICE_TYPES = '[devices] add alarm device types';
export const LOAD_ALARM_DEVICE_TYPES = '[devices] load alarm device types';

export const PROCESS_ALARM_DEVICE_TYPES =
  '[devices] process alarm device types';

export const LOAD_ASSIGNED_ALARM_DEVICE_DETAILS =
  '[devices] load assigned alarm device details';
export const PROCESS_ASSIGNED_ALARM_DEVICE_DETAILS =
  '[devices] process assigned alarm device details';
export const INSERT_ASSIGNED_ALARM_DEVICE_DETAILS =
  '[devices] insert assigned alarm device details';

export const LOAD_SPECIFIC_ALARM_DEVICE_DETAILS =
  '[devices] load specific alarm device detail';

export const PROCESS_SPECIFIC_ALARM_DEVICE_DETAILS =
  '[devices] process specific alarm device detail';

export const ADD_SPECIFIC_ALARM_DEVICE_DETAILS = 
  '[devices] add specific alarm device details'

export const loadAssignedAlarmDevicesDetails = () => ({
  type: LOAD_ASSIGNED_ALARM_DEVICE_DETAILS,
});

export const processAssignedAlarmDevicesDetails = (payload) => ({
  type: PROCESS_ASSIGNED_ALARM_DEVICE_DETAILS,
  payload,
});

export const loadUnassignedAlarmDevicesDetails = () => ({
  type: LOAD_UNASSIGNED_ALARM_DEVICE_DETAILS,
});

export const loadUnassignedPoiDevicesDetails = () => ({
  type: LOAD_UNASSIGNED_POI_DEVICE_DETAILS,
});

export const processUnassignedAlarmDevicesDetails = (payload) => ({
  type: PROCESS_UNASSIGNED_ALARM_DEVICE_DETAILS,
  payload,
});

export const loadAlarmDeviceDetails = (payload) => ({
  type: LOAD_ALARM_DEVICE_DETAILS,
  payload,
});

export const processAlarmDeviceDetails = (payload) => ({
  type: PROCESS_ALARM_DEVICE_DETAILS,
  payload,
});

export const addAlarmDeviceDetails = (payload) => ({
  type: ADD_ALARM_DEVICE_DETAILS,
  payload,
});

export const addAssignedAlarmDevices = (payload) => ({
  type: ADD_ASSIGNED_ALARM_DEVICES,
  payload,
});

export const addAlarmDeviceTypes = (payload) => ({
  type: ADD_ALARM_DEVICE_TYPES,
  payload,
});
export const loadAlarmDeviceTypes = (payload) => ({
  type: LOAD_ALARM_DEVICE_TYPES,
  payload,
});
export const processAlarmDeviceTypes = (payload) => ({
  type: PROCESS_ALARM_DEVICE_TYPES,
  payload,
});

export const loadSpecificAlarmDevicesDetails = (payload) => ({
  type: LOAD_SPECIFIC_ALARM_DEVICE_DETAILS,
  payload,
});

export const processSpecificAlarmDevicesDetails = (payload) => ({
  type: PROCESS_SPECIFIC_ALARM_DEVICE_DETAILS,
  payload,
});

export const addSpecificAlarmDeviceDetails = (payload) => ({
  type: ADD_SPECIFIC_ALARM_DEVICE_DETAILS,
  payload,
});